import {EntityBase} from "../../../shared/entity/EntityBase";
import dayjs from "dayjs";

const PERSONAL_PACKAGE_FIELDS = {
    seq: {type: parseInt, defaultValue: 0},
    memo: {defaultValue: ''},
    lastPayment: {type: Number, defaultValue: 0},
    averagePayment: {type: Number, defaultValue: 0},
    paymentCount: {type: Number, defaultValue: 0},
    baseDate: {defaultValue: dayjs().format('YYYY-MM-DD')},
    cumulativeLoginCount: {type: Number, defaultValue: 0},
    cumulativePayment: {type: Number, defaultValue: 0},
    isCumPaymentOver: {type: Number, defaultValue: 1},
};

export class PersonalPackageEntity extends EntityBase {
    constructor(data = {}) {
        super(data, PERSONAL_PACKAGE_FIELDS);
        this.errors = [];
    }

    getIdentityKey() {
        return 'seq';
    }
}